import React, { useState } from 'react';
import { PageSection } from '@patternfly/react-core';
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb';
import GenericAlert from '../components/GenericAlert';
import { PATH_TO_FO_PRIVACY } from 'src/app/utils/RoutesConstants';

const breadcrumbOptions = [
  { label: 'Informativa privacy', link: PATH_TO_FO_PRIVACY }
];

const Privacy: React.FC = () => {
  const [message] = useState('');
  const [typeMessage] = useState<'default' | 'info' | 'warning' | 'success' | 'danger'>('default');

  return (
    <PageSection id="pageSectionId">
      <div className="container register-container">
        <GenericBreadCrumb paths={breadcrumbOptions} />
        <h1>Informativa privacy</h1>
        <GenericAlert hidden={message === ''} label={message} color={typeMessage} />

        <section>
          <p>
            Il Consiglio Nazionale dei Dottori Agronomi e dei Dottori Forestali - Cod. Fiscale 80247570585 - Via Po 22 - 00198 ROMA - Tel. 06-8540174 - Email: protocollo@conafpec.it / serviziosegreteria@conaf.it - (in seguito, “Titolare”), in qualità di titolare del trattamento dei dati, comunica che, ai sensi dell’art. 13 D. Lgs. 30.6.2003 n.196 come successivamente novellato dal D. Lgs 101/2018 e dell’art. 13 Regolamento UE n. 2016/679 (“GDPR”), i dati personali saranno trattati anche attraverso il sito istituzionale dell’ente con le modalità e per le finalità seguenti.
          </p>

          <h2>1. Oggetto del trattamento e finalità</h2>
          <p>
            Il Titolare tratta dati personali ed identificativi (indirizzo, nome utente, nome, cognome, email, numero telefonico, indirizzo, dati biometrici e sanitari ai sensi dell’art. 9 GDPR) comunicati dall’interessato:
          </p>
          <ul>
            <li>in occasione dell’accesso al sito istituzionale;</li>
            <li>in occasione di procedure di manifestazione di interesse e attività connesse;</li>
            <li>in occasione della conclusione di contratti e/o richieste di servizi.</li>
          </ul>
          <p>
            Il trattamento potrà avvenire per eseguire obblighi di legge, finalità istituzionali, esigenze operative e gestionali.
          </p>

          <h2>2. Modalità del trattamento</h2>
          <p>
            Il trattamento è effettuato tramite operazioni indicate all’art. 4 del Codice Privacy e art. 4 n.2 del GDPR (raccolta, registrazione, elaborazione, ecc.), sia su supporto cartaceo che elettronico/automatizzato. Il conferimento dei dati è obbligatorio per dar corso alle procedure richieste.
          </p>

          <h2>3. Accesso ai dati</h2>
          <p>I dati potranno essere accessibili a:</p>
          <ul>
            <li>Dipendenti e collaboratori del Titolare, in qualità di incaricati o responsabili;</li>
            <li>Società terze o soggetti esterni che svolgono attività in outsourcing per conto del Titolare.</li>
          </ul>

          <h2>4. Comunicazione dei dati</h2>
          <p>
            I dati potranno essere comunicati, senza necessità di consenso, a soggetti pubblici per obblighi di legge (Organismi di vigilanza, autorità giudiziarie, PA, ecc.) e non saranno diffusi.
          </p>

          <h2>5. Diritti dell’interessato</h2>
          <p>L’interessato ha diritto di:</p>
          <ul>
            <li>ottenere conferma dell’esistenza dei dati e riceverne comunicazione in forma intelligibile;</li>
            <li>ottenere indicazioni su origine, finalità, logica del trattamento, soggetti coinvolti;</li>
            <li>ottenere aggiornamento, rettifica, cancellazione o anonimizzazione dei dati trattati illecitamente;</li>
            <li>opporsi, per motivi legittimi, al trattamento o per finalità commerciali o pubblicitarie.</li>
          </ul>
          <p>
            Sono garantiti anche i diritti degli artt. 16-21 GDPR (rettifica, oblio, limitazione, portabilità, opposizione), oltre al diritto di reclamo all’Autorità Garante.
          </p>

          <h2>6. Durata del trattamento</h2>
          <p>
            I dati saranno trattati per il tempo previsto dalla legge e non oltre quanto necessario per il servizio richiesto e le finalità istituzionali.
          </p>

          <h2>7. Modalità di esercizio dei diritti</h2>
          <p>
            È possibile esercitare i diritti inviando raccomandata a/r a: <br />
            Consiglio Nazionale dei Dottori Agronomi e dei Dottori Forestali - Via Po 22 - 00198 ROMA
          </p>

          <h2>8. Titolare, responsabile e incaricati</h2>
          <p>
            Il Titolare è il Consiglio Nazionale dei Dottori Agronomi e dei Dottori Forestali.<br />
            Il Responsabile per la protezione dei dati è l’avv. Maria Vittoria Colonna - Email: mvittoria.colonna@gmail.com - PEC: mariavittoriacolonna@ordineavvocatiroma.org.<br />
            L’elenco aggiornato dei responsabili è disponibile presso la sede del Titolare.
          </p>
        </section>
      </div>
    </PageSection>
  );
};

export default Privacy;
